/**
 * Created by jacky on 3/12/16.
 * @flow
 * @providesModule Task
 */

import React, { Component } from "react";
import type {TaskInfoType, PointType} from "../../lib/stories-shared";
import {processTextNode} from "../../lib/stories-shared";
import {findDOMNode} from "react-dom";
import {isMobileBrowser} from '../../lib/utils';

require("./task.scss");

type TaskPropsType = {
    task: TaskInfoType;
    axis: PointType;
    width: number;
    height: number;
    onDblClick: Function;
}

class Task extends Component {
    props: TaskPropsType;

    componentDidMount() {
        processTextNode(findDOMNode(this.refs['taskName']));
    }

    render() {
        const {x, y} = this.props.axis;
        const t = `translate(${x},${y})`;
        const v = isMobileBrowser ? {onTouchTap: this._dblClick} : {};
        return (
            <g className="clsTask" transform={t} onDoubleClick={this._dblClick} {...v}>
                <rect className="clsGroupRects" rx={5} ry={5} width={this.props.width} height={this.props.height} x={0} y={0} />
                <text className="clsTaskName" x={6} y={8} ref="taskName">
                    {this.props.task.name}
                </text>
            </g>
        );
    }

    _dblClick = () => {
        this.props.onDblClick(this.props.task);
    }
}

export default Task;



// WEBPACK FOOTER //
// ./src/components/Task/task.jsx